import Transfer, { TransferDirection } from "antd/lib/transfer";
import { useState } from "react";
import { IExportGenerator } from "../domain/ExportGenerators/IExportGenerator";

interface IProps {
    generators: IExportGenerator[];
    onChange: (selectedGenerators: IExportGenerator[]) => any;
}
export function ExportGeneratorSelector(props: IProps) {
    const { generators, onChange } = props;
    const [targetKeys, setTargetKeys] = useState<string[]>([]);
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

    const onTransferChange = (nextTargetKeys: string[], direction: TransferDirection, moveKeys: string[]) => {
        setTargetKeys(nextTargetKeys);
        onChange(generators.filter(x => nextTargetKeys.includes(x.id)));
    };

    const onSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    };

    return (
        <Transfer
            dataSource={generators}
            listStyle={{ width: "100%" }}
            rowKey={(item) => item.id}
            titles={['Available', 'Selected']}
            targetKeys={targetKeys}
            selectedKeys={selectedKeys}
            onChange={onTransferChange}
            onSelectChange={onSelectChange}
            render={(item) => <>{item.name}</>}
        />
    );;
}
